import { components } from '../../../generated/api/schema';
import { Person } from './person';

export type UserDetailDto = components['schemas']['UserDetailsDto'];
export type CreateUserRequest = components['schemas']['CreateUserRequest'];
export type UpdateUserRequest = components['schemas']['UpdateUserRequest'];
export type AgreementDto = components['schemas']['AgreementDto'];
export type AgreementWithInstitutionsDto = components['schemas']['AgreementWithInstitutionsDto'];
export type InstitutionDto = components['schemas']['InstitutionDto'];
export type AccountDto = components['schemas']['AccountDto'];

export enum Role {
  LocalAdmin = 'LOCAL_ADMIN',
  LocalAdminPlus = 'LOCAL_ADMIN_PLUS',
  Guardian = 'GUARDIAN',
  SchoolEmployee = 'SCHOOL_EMPLOYEE',
  SchoolEmployeePlus = 'SCHOOL_EMPLOYEE_PLUS',
  MunicipalityEmployee = 'MUNICIPALITY_EMPLOYEE',
  SuperUser = 'SUPER_USER',
  Unknown = 'UNKNOWN',
  None = 'NONE',
}
export type UserRole =
  | 'LOCAL_ADMIN'
  | 'LOCAL_ADMIN_PLUS'
  | 'GUARDIAN'
  | 'SCHOOL_EMPLOYEE'
  | 'SCHOOL_EMPLOYEE_PLUS'
  | 'MUNICIPALITY_EMPLOYEE'
  | 'SUPER_USER'
  | 'UNKNOWN'
  | 'NONE';
export type UserRoles = UserRole[];

export const AVAILABLE_ROLES = Object.freeze([
  Role.SuperUser,
  Role.MunicipalityEmployee,
  Role.LocalAdmin,
  Role.SchoolEmployee,
  Role.Guardian,
  Role.LocalAdminPlus,
  Role.SchoolEmployeePlus,
] as const satisfies readonly UserRole[]);

export enum AuthTypes {
  BANK_ID = 'BANK_ID',
  MFA = 'MFA',
  USERNAME_PASSWORD = 'USERNAME_PASSWORD',
}
export type AuthenticationTypes = ('BANK_ID' | 'MFA' | 'USERNAME_PASSWORD')[];
export type UserDto = components['schemas']['UserSearchItemDto'];
// UserSearchRequest was removed from the generated schema; defined locally to match the V1 POST body.
export interface UserSearchRequest {
  nameSearch?: { name: string[] };
  userIds?: number[];
  pageNumber?: number;
  itemsPerPage?: number;
}

// OLD TYPES

export type User = components['schemas']['UserDetailsDto'];

export interface UserOld {
  userID: number;
  usertype: number;
  customerID: number;
  companyNo: number;
  email: string;
  username: string;
  password: string;
  freeReferenceID: boolean;
  active: boolean;
  firstName: string;
  lastName: string;
  freeProjectID: boolean;
  language: string;
  phone: string;
  mobile: string;
  agreementID: number;
  projectID: string;
  customerRefNo: string;
  comment: string;
  passwordExpirationDate: number;
  agreements?: Agreement[];
  persons?: Person[];
  rights: Rights;
  accounts: unknown[];
  addresses: unknown[];
}

type Rights = Record<string, never>;

export interface AgreementAccount {
  accountNo: number;
  helpText: string;
  name: string;
}

interface Agreement {
  accounts: AgreementAccount[];
  agreementID: number;
  name: string;
}

export interface CreateUserData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  agreementID: number;
  persons: Person[];
  language: string;
  username: string;
}

export interface EditUserData extends Omit<CreateUserData, 'username'> {
  userID: number;
}

export type GetUserResponse = User;

export interface CreateUserResponse {
  key: number;
  success: boolean;
  message: string;
}

export interface GetUsersResponse {
  count: number;
  items: User[];
}

export type EditUserResponse = CreateUserResponse;

export interface AddressType {
  id: number;
  name: string;
}

export interface TravellerData {
  addressTypes: AddressType[];
  contactTypes: {
    id: number;
    name: string;
  }[];
  attributes: {
    attributeID: number;
    code: string;
  }[];
}
